<!-- eslint-disable max-lines -->
<template>
    <paper>
        <m-pane
                ref="tablePage"
                :config="config"
                :totalData="totalData"
                :pageTotal="pageTotal"
                :optionNum="optionNum"
                :loading="loading"
                @saveData="saveData"
                @edit-btn="editBtn"
                @searchChange="searchChange"
                @selectChange="selectChange"
                @pageChange="pageChange"
                @sizeChange="sizeChange"
                searchId="test"
                pageID="test">
            <div slot="table-module-btn">
                <el-tooltip class="item" effect="dark" content="新增" placement="bottom">
                    <el-button size="mini" icon='el-icon-plus' @click="addData"></el-button>
                </el-tooltip>
            </div>
            <div slot="page-module-btn">
                <span v-has="'otp05070001'"><el-button type="primary" @click="redomet">删 除</el-button></span>
                <span style="margin-left: 10px;" v-has="'otp05070002'"><el-button type="primary" @click="saveData">保 存</el-button></span>
            </div>
        </m-pane>
    </paper>
</template>
<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import mPane from '@/components/otpPanel';
import config from './config.json';
import paper from '@/components/core/paper/Paper';
import { getWhConfigs, batchUpdateWhConfig, batchDeleteWhConfig, getWhConfigsCount } from '../../../api/configCenter';
import { saveArr } from '../../../judge/configCenter';
import { messageBox } from '../../../utils/messageBox';

const PAGE_TOTAL = 10000;
export default {
    name: 'storehouse',
    components: { mPane, paper },
    data() {
        return {
            config: config,
            loading: false,
            optionNum: '',
            totalData: [],
            // 选中的行数
            selectData: [],
            pageTotal: 0,
            mustFillParams: {
                orderType: '',
                businessMode: '',
                whCode: '',
                whName: '',
                logisitcMode: ''
            },
            searchParams: {
                pageSize: 10,
                pageNo: 1
            }
        };
    },
    methods: {
        async fetchData(searchCountFlag) {
            const res = await getWhConfigs(this.searchParams);
            if (res) {
                const data = res.data || {};
                if (data.totalPage !== 0 && this.searchParams.pageNo > data.totalPage) {
                    this.searchParams.pageNo = data.totalPage;
                    this.fetchData();
                } else {
                    this.totalData = (data.list || []).map(item => {
                        return { ...this.mustFillParams, ...item };
                    });
                    if (!searchCountFlag) { this.getPageTotal(); }
                }
            } else {
                this.totalData = [];
            }
        },
        async getPageTotal() {
            const totalCountRes = await getWhConfigsCount(this.searchParams);
            this.pageTotal = totalCountRes ? totalCountRes.data : PAGE_TOTAL;
        },
        rowDBclick(row) {
            // 表格内双击事件
        },
        checkBtn(data) {
            // 表格内按钮查看事件;
        },
        editBtn(data) {
            // 表格内按钮修改事件;
        },
        delBtn(data) {
            // 表格内按钮删除事件;
        },
        selectChange(data) {
            // 表格内选择变化
            this.selectData = data;
        },
        switchChange(data) {
            // 表格内switch切换事件
        },
        searchChange(data) {
            // 提交搜索框
            this.searchParams = { ...this.searchParams, ...data, pageNo: 1 };
            this.fetchData();
        },
        pageChange(data) {
            // 分页器页数变化
            this.searchParams.pageNo = data;
            this.fetchData(true);
        },
        sizeChange(data) {
            // 分页器页数大小变化
            this.searchParams.pageSize = data;
            this.fetchData(true);
        },
        addData() {
            // 表格新增方法
            this.$refs.tablePage.$refs.table.addRow();
        },
        async saveData() {
            // 表单未选判断
            const msg = this.$refs.tablePage.$refs.table.$refs.mNewTable.saveData();
            if (!msg) {
                return;
            }
            if (!saveArr(msg)) {
                this.$message.error('至少勾选一条数据进行操作');
                return;
            }

            // 表格新增修改后返回数据
            const selectData = this.selectData.map(item => {
                const obj = item.id ? { id: item.id } : {};
                const { orderType, businessMode, whCode, whName, logisitcMode, version } = item;
                return { orderType, businessMode, whCode, whName, logisitcMode, version, ...obj };
            });
            const res = await batchUpdateWhConfig(selectData);
            if (res && res.code === '0') {
                this.$message.success('保存成功');
                this.fetchData();
            }
        },
        async redomet() {
            // 这是删除方法
            if (this.selectData.length < 1) {
                this.$message.warning('至少勾选一条数据进行操作');
                return;
            }
            // 表格删除后返回数据
            const selectData = this.selectData.map(item => item.id);
            messageBox(this).then(async () => {
                const res = await batchDeleteWhConfig(selectData);
                if (res && res.code === '0') {
                    this.$message.success('删除成功');
                    this.fetchData();
                }
            });
        },
        getTableConfigList(data) {
        },
        refresh() {
            // 表格内刷新按钮
        }
    },
    mounted() {
        this.fetchData();
    }
};
</script>
